import React from 'react';

import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  autoFocus?: boolean;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder,
  autoFocus = true,
}) => (
  <Input
    autoFocus={autoFocus}
    allowClear
    prefix={<SearchOutlined className="text-gray-muted" />}
    placeholder={placeholder}
    value={value}
    onChange={(event) => onChange(event.target.value)}
  />
);

export default SearchInput;
